/** Registered insurance agents use the portal with self + downline visibility. */
export const AGENT_PORTAL_ROLE = "AGENT";
export const AGENT_PORTAL_ACCESS_SCOPE = "DOWNLINE";
export function isAgentPortalUser(input) {
    return input.role === AGENT_PORTAL_ROLE && !input.isStaff;
}
export function parseCommissionLevel(level) {
    if (!level)
        return null;
    const normalized = level.trim().toUpperCase();
    if (normalized === "LOA")
        return null;
    const match = normalized.match(/^(\d+(?:\.\d+)?)/);
    if (!match)
        return null;
    return Number.parseFloat(match[1]);
}
/**
 * Commission levels a downline invite may be sent at, capped at the upline's
 * own level (higher-numbered percentages are "better," so a downline can't
 * be invited above the person inviting them). `LOA` and unparsed levels are
 * always offered since they aren't part of the percentage ordering.
 */
export function selectableCommissionLevels(allLevels, uplineLevel) {
    const cap = parseCommissionLevel(uplineLevel);
    if (cap === null)
        return [...allLevels];
    return allLevels.filter((level) => {
        const parsed = parseCommissionLevel(level);
        return parsed === null || parsed <= cap;
    });
}
export function generateReferralCodeValue(length = 10) {
    const alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let code = "";
    for (let i = 0; i < length; i += 1) {
        code += alphabet[Math.floor(Math.random() * alphabet.length)];
    }
    return code;
}
